import { IntegratedPaging, IntegratedSorting, PagingState, SortingState } from '@devexpress/dx-react-grid';
import {
  DragDropProvider,
  Grid as ReactGrid,
  PagingPanel,
  Table,
  TableColumnReordering,
  TableHeaderRow,
} from '@devexpress/dx-react-grid-material-ui';
import { Button, Chip, TableCell } from '@material-ui/core';
import green from '@material-ui/core/colors/green';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import {
  Close as CloseIcon,
  CloudDownload as CloudDownloadIcon,
  Error as ErrorIcon,
  Info as InfoIcon,
  Search as SearchIcon,
  CheckCircle as SuccessIcon,
} from '@material-ui/icons';
import { Avatar, Grid, IconButton, LinearProgress, Paper, Snackbar, TextField } from 'material-ui';
import { SnackbarContent } from 'material-ui/Snackbar';
import { withStyles } from 'material-ui/styles';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import postGenerateHtmlFromRawData from '../../actions/postGenerateHtmlFromRawData';
import search from '../../actions/search';
import searchDataRetention from '../../actions/searchDataRetention';
import compareCaseInsensitive from '../../helpers/CompareCaseInsensitive';
import optional from '../../helpers/OptionalAccess';

import Layout from '../Layout';
import ReportMenu from './SelectReportMenu';


const snackIcons = {
  error: ErrorIcon,
  info: InfoIcon,
  success: SuccessIcon,
};

const styles = theme => (
  {
    chip: {
      margin: '24px 0 0',
    },
    downloadIndicator: {
      padding: '1em',
    },
    formControl: {
      margin: 8,
      minWidth: 120,
      width: 350,
    },
    inputRoot: {
      width: '100%',
    },
    linearProgress: {
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
    },
    marginLeft: {
      marginLeft: '8px',
    },
    menuTableCell: {
      paddingLeft: '0 !important',
    },
    paper: {
      width: '80%',
      margin: "1.5em auto",
      display: "flex",
      flexDirection: "column",
      padding: "2em",
      height: "25%",
      justifyContent: "space-between",
    },
    row: {
      margin: '.5em 0',
    },
    searchForm: {
      width: '80%',
      height: '70%',
      display: 'inline-block',
      margin: 20,
      marginTop: '3vh',
    },
    snack: {
      top: '16px',
    },
    error: {
      background: theme.palette.error.dark,
      color: '#fff',
    },
    info: {
      background: theme.palette.primary.dark,
      color: '#fff',
    },
    success: {
      background: green[600],
      color: '#fff',
    },
    snackClose: {
      padding: 4,
    },
    snackMessage: {
      display: 'flex',
      alignItems: 'center',
    },
    textField: {
      width: 350,
    },
  }
);

const getRowId = row => row.requestId;


class DataRetentionSearch extends Component {
  constructor(props) {
    super(props);

    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    this.state = {
      columns: [
        { name: 'date', title: 'Date' },
        { name: 'vinCount', title: 'VIN Count' },
        { name: 'application', title: 'Application' },
        { name: 'name', title: 'User' },
        { name: 'reports', title: 'Reports' },
      ],
      columnOrder: ['date', 'application', 'vinCount', 'name', 'reports'],
      currentPage: 0,
      locations: [],
      persons: [],
      downloadingReport: false,
      snackMessage: false,
      snackVariant: 'error',
      loading: false,
      pageSize: 25,
      pageSizes: [25, 50, 100, 0],
      rows: undefined,
      sorting: [{ columnName: 'date', direction: 'asc' }],
      tableColumnExtensions: [],
      application: 'all',
      autotecId: 'all',
      vins: '',
      beginDate: this.formatDate(yesterday),
      endDate: this.formatDate(today),
    };
  }

  formatDate = (date) => {
    const year = date.getFullYear();
    const month = '0' + (
      date.getMonth() + 1
    );
    const day = '0' + date.getDate();

    return `${year}-${month.slice(-2)}-${day.slice(-2)}`;
  };

  cellComponent = (cellProps) => {
    const { classes } = this.props;
    const { column, row, value } = cellProps;
    const rowId = getRowId(row);

    if (column.name === 'reports') {
      return (
        <TableCell className={classes.menuTableCell}>
          <ReportMenu
            classes={classes}
            id={rowId}
            items={value}
            handleViewHtml={this.showReportHtml}
            handleViewJson={this.showReportJson}
          />
        </TableCell>
      );
    }

    return <Table.Cell {...cellProps} />;
  };

  changeCurrentPage = currentPage => this.setState({ currentPage });

  changeColumnOrder = columnOrder => this.setState({ columnOrder });

  changePageSize = pageSize => this.setState({ pageSize });

  changeSorting = sorting => this.setState({ sorting });

  closeSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    this.setState({ snackMessage: false });
  };

  handleSearch = () => {
    let { autotecId, application, vins, beginDate, endDate } = this.state;
    const { data: { config } } = this.props;

    if (autotecId === 'all') {
      autotecId = undefined;
    }

    if (application === 'all') {
      application = undefined;
    }

    if (vins === '') {
      vins = undefined;
    }

    if (beginDate === '') {
      beginDate = undefined;
    }

    if (endDate === '') {
      endDate = undefined;
    }

    this.setState({
      loading: true,
      rows: [],
      snackMessage: 'Attempting to start query...',
      snackVariant: 'info',
    });
    this.queryReportHistory({
      autotecId,
      application,
      vins,
      beginDate,
      endDate,
      config,
      self: this,
    });
  };

  getPersonById = (personId) => {
    if (!this.persons || !personId) return 'Machine';

    const person = this.persons.find(p => p.personId === personId);
    if (!person) return 'Machine';

    return `${person.firstName} ${person.lastName}`;
  };

  queryReportHistory = ({ ...variables, self }) => {
    const { rows: existingRows } = this.state;
    const { actions } = this.props;

    actions
      .searchData({ ...variables, self })
      .then((response) => {
        const data = optional(response, ['value', 'data'], undefined);
        const {
          queryId,
          nextToken,
          state,
          message,
          items,
        } = data;

        if (state === 'QUEUED' || state === 'RUNNING') {
          self.setState({
            snackMessage: `Query is ${state.toLowerCase()}, please wait...`,
            snackVariant: 'info',
          });

          setTimeout(() => {
            this.queryReportHistory({ ...variables, queryId, nextToken, self });
          }, 2000);
        } else if (state === 'SUCCEEDED') {
          // map items to a new list of rows
          // with existing rows concated
          const rows = items.map((req) => (
            {
              requestId: req.requestId,
              date: req.date,
              vinCount: parseInt(req.vinCount, 10),
              name: this.getPersonById(req.userId),
              application: req.application,
              reports: req.reports.map(report => {
                const flattened = {
                  ...req,
                  ...report,
                };

                // reports is redundant, so delete it
                delete flattened['reports'];

                return flattened;
              }).sort((a, b) => {
                // sort reports in alpha order
                const nameA = a.reportType.toLowerCase();
                const nameB = b.reportType.toLowerCase();

                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;

                return 0;
              }),
            }
          )).concat(existingRows);

          // update state
          self.setState({
            rows,
            loading: false,
            snackMessage: 'Query finished successfully!',
            snackVariant: 'success',
          });

          if (nextToken) {
            this.queryReportHistory({ ...variables, queryId, nextToken, self });
          }
        } else {
          self.setState({
            snackMessage: message || 'There was an error completing the query!',
            snackVariant: 'error',
            loading: false,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        self.setState({
          snackMessage: 'There was an error completing the query!',
          snackVariant: 'error',
          loading: false
        });
      });
  };

  showDataRetentionScreen() {
    const { person } = this.props.data;
    if (!person) return false;

    const autotecLocation = person.locations.find((l) => l.autotecId === 'ACDV0036');
    if (!autotecLocation) return false;

    const { name: roleName } = autotecLocation.role;
    if (!roleName || roleName !== 'sysadmin') return false;

    return true;
  }

  showReportHtml = (reportData) => {
    const { reportType } = reportData;
    const { actions, data: { config } } = this.props;

    actions.showSelectedReport(reportType, reportData, true, config, this);
  };

  showReportJson = (reportData) => {
    const { reportType } = reportData;
    const { actions, data: { config } } = this.props;

    actions.showSelectedReport(reportType, reportData, false, config, this);
  };

  componentDidMount() {
    const { data: { config }, actions } = this.props;

    this.setState({
      snackMessage: 'Loading locations and products...',
      snackVariant: 'info',
      loading: true,
    });

    const promises = [
      actions.getLocations(config, this),
      actions.getPersons(config, this),
    ];

    Promise
      .all(promises)
      .finally(() => this.setState({
        loading: false,
        snackMessage: false,
      }));
  }

  render() {
    const { classes } = this.props;
    const {
      columns,
      columnOrder,
      currentPage,
      downloadingReport,
      snackMessage,
      snackVariant,
      loading,
      pageSize,
      pageSizes,
      rows,
      sorting,
      tableColumnExtensions,
    } = this.state;

    const SnackIcon = snackIcons[snackVariant];

    // do not show the screen if user is not authorized
    if (!this.showDataRetentionScreen()) {
      return (
        <Layout
          className="App"
          showMenu
          toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727."
        >
          <div className={classes.paper}>
            Unauthorized
          </div>
        </Layout>
      );
    }

    console.log(snackVariant, classes.snackVariant);

    return (
      <Layout
        className="App"
        showMenu
        toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727."
      >
        {Boolean(loading || downloadingReport) && <LinearProgress className={classes.linearProgress} />}
        {
          Boolean(downloadingReport) && (
            <React.Fragment>
              <div className={classes.downloadIndicator}>
                <Chip
                  avatar={
                    <Avatar>
                      <CloudDownloadIcon />
                    </Avatar>
                  }
                  label={`Downloading ${downloadingReport} Report...`}
                  className={classes.chip}
                  color="primary"
                />
              </div>
            </React.Fragment>
          )
        }
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={Boolean(snackMessage) !== false}
          className={classes.snack}
          onClose={this.closeSnackbar}
        >
          <SnackbarContent
            className={classes[snackVariant]}
            message={
              <span className={classes.snackMessage}>
                <SnackIcon style={{ marginRight: 4 }} /> {snackMessage}
              </span>
            }
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                className={classes.snackClose}
                onClick={this.closeSnackbar}
              >
                <CloseIcon />
              </IconButton>,
            ]}
          />
        </Snackbar>
        <Paper className={classes.paper}>
          <Grid className={classes.row} container item justify="space-around">
            <Grid item xs={4}>
              <FormControl className={classes.formControl}>
                <InputLabel id="select-autotecId">Location</InputLabel>
                <Select
                  disabled={this.state.loading}
                  id="select-autotecId"
                  value={this.state.autotecId}
                  onChange={event => this.setState({ autotecId: event.target.value })}
                >
                  <MenuItem selected value="all">All Locations</MenuItem>
                  {
                    this.state.locations
                      .map((location) => {
                        return (
                          <MenuItem
                            key={location.locationId}
                            value={location.autotecId}
                          >
                            {location.locationName}
                          </MenuItem>
                        );
                      })
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl className={classes.formControl}>
                <InputLabel id="select-product">Product</InputLabel>
                <Select
                  disabled={this.state.loading}
                  id="select-product"
                  value={this.state.application}
                  onChange={event => this.setState({ application: event.target.value })}
                >
                  <MenuItem selected value="all">All Products</MenuItem>
                  <MenuItem value="aca">All ACA</MenuItem>
                  <MenuItem value="aca-ui">ACA UI</MenuItem>
                  <MenuItem value="aca-api">ACA API</MenuItem>
                  <MenuItem value="aci">All ACI</MenuItem>
                  <MenuItem value="aci-ui">ACI UI</MenuItem>
                  <MenuItem value="aci-api">ACI API</MenuItem>
                  <MenuItem value="vxc">All VXC</MenuItem>
                  <MenuItem value="vxc-ui">VXC UI</MenuItem>
                  <MenuItem value="vxc-api">VXC API</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <TextField
                name="vins"
                label="VIN"
                className={classes.textField}
                onChange={event => this.setState({ vins: event.target.value })}
                value={this.state.vins}
                helperText="Separate multiple VINs with a comma."
              />
            </Grid>
          </Grid>
          <Grid className={classes.row} container item justify="space-around" alignItems="flex-end">
            <Grid item xs={4}>
              <TextField
                name="beginDate"
                label="Begin Date"
                className={classes.textField}
                onChange={event => this.setState({ beginDate: event.target.value })}
                value={this.state.beginDate}
                type="date"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                name="endDate"
                label="End Date"
                className={classes.textField}
                onChange={event => this.setState({ endDate: event.target.value })}
                value={this.state.endDate}
                type="date"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={4}>
              <Button
                color="primary"
                disabled={this.state.loading}
                variant="contained"
                style={{
                  width: 350,
                }}
                onClick={() => this.handleSearch()}
              >
                <SearchIcon /> Search
              </Button>
            </Grid>
          </Grid>
          {
            Boolean(!loading && rows) && (
              <ReactGrid
                rows={rows}
                columns={columns}
                getRowId={getRowId}
              >
                <SortingState
                  sorting={sorting}
                  onSortingChange={this.changeSorting}
                />
                <PagingState
                  currentPage={currentPage}
                  pageSize={pageSize}
                  onCurrentPageChange={this.changeCurrentPage}
                  onPageSizeChange={this.changePageSize}
                />

                <IntegratedSorting />
                <IntegratedPaging />

                <DragDropProvider />

                <Table
                  columnExtensions={tableColumnExtensions}
                  cellComponent={this.cellComponent}
                />

                <TableColumnReordering
                  order={columnOrder}
                  onOrderChange={this.changeColumnOrder}
                />

                <TableHeaderRow showSortingControls />
                <PagingPanel
                  pageSizes={pageSizes}
                />
              </ReactGrid>
            )
          }
        </Paper>
      </Layout>
    );
  }
}


const mapStateToProps = state => (
  {
    data: {
      person: state.person.person,
      config: state.config.config,
    },
  }
);

const mapDispatchToProps = dispatch => (
  {
    actions: {
      getLocations: (config, self) => {
        return dispatch(search('locations', 0, null, config))
          .then((result) => {
            const { items } = result.value.data;
            const locations = items.sort((a, b) => compareCaseInsensitive(a.locationName, b.locationName));

            self.setState({ locations });
          })
          .catch((error) => {
            console.log(error);
            self.setState({
              snackMessage: 'Error retrieving locations!',
              snackVariant: 'error',
            });
          });
      },
      getPersons: (config, self) => {
        return dispatch(search('persons', 0, undefined, config))
          .then((result) => {
            const { items: persons } = result.value.data;
            self.setState({ persons });
          })
          .catch((error) => {
            console.log(error);
            self.setState({
              snackMessage: 'Error retrieving users!',
              snackVariant: 'error',
            });
          });
      },
      searchData: async ({ autotecId, beginDate, endDate, vins, application, queryId, nextToken, config, self }) => {
        let encodedNextToken = undefined;
        if (nextToken) {
          encodedNextToken = encodeURIComponent(nextToken);
        }

        const data = {
          autotecId,
          beginDate,
          endDate,
          application,
          vins,
          queryId,
          encodedNextToken,
        };

        return dispatch(searchDataRetention(data, config));
      },
      showSelectedReport: (reportType, reportData, showHtml, config, self) => {
        function writeHTMLToNewWindow(name, html) {
          const tab = window.open('', name);
          if (!tab) {
            return null;
          }

          tab.document.write(html);
          tab.document.close();

          return tab;
        }

        function syntaxHighlight(json) {
          json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
          return json.replace(
            /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
            function(match) {
              let cls = 'number';
              if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                  cls = 'key';
                } else {
                  cls = 'string';
                }
              } else if (/true|false/.test(match)) {
                cls = 'boolean';
              } else if (/null/.test(match)) {
                cls = 'null';
              }
              return '<span class="' + cls + '">' + match + '</span>';
            },
          );
        }

        if (showHtml) {
          self.setState({ downloadingReport: reportType });

          dispatch(postGenerateHtmlFromRawData(reportType, reportData, config))
            .then((result) => {
              const { reportName, reportHtml } = result.value.data;
              writeHTMLToNewWindow(reportName, reportHtml);

              self.setState({ downloadingReport: false });
            })
            .catch((error) => {
              console.log(error);
              self.setState({
                downloadingReport: false,
                snackMessage: 'Error retrieving report!',
                snackVariant: 'error',
              });
            });
        } else {
          const json = syntaxHighlight(JSON.stringify(reportData, null, 2));
          const html = `<!doctype html>
<html>
  <head>
    <title>${reportType} Report</title>
    <style>
      pre { padding: 5px; margin: 5px; }
      .string { color: green; }
      .number { color: darkorange; }
      .boolean { color: blue; }
      .null { color: magenta; }
      .key { color: red; }
    </style>
  </head>
  <body>
    <pre>${json}</pre>
  </body>
</html>`;

          writeHTMLToNewWindow(reportType, html);
        }
      },
    },
  }
);

const ConnectedDataRetentionSearch = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DataRetentionSearch);

export default withStyles(styles, { name: 'DataRetentionSearch' })(ConnectedDataRetentionSearch);


// WEBPACK FOOTER //
// ./src/components/Account/DataRetentionSearch.js